import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAllCompanies, setIsNeedCompaniesRefresh } from "../redux/adminCompaniesSlice"
import { GreenButton } from "../components/buttons"
import AdminCard from "../components/AdminCard"
import Loader from "../components/Loader"
import Error from "../components/Error"
import { setBacklink } from "../redux/backlinkSlice"

const HandleCompanies = () => {
    const { data, isLoading, error, isNeedRefresh } = useSelector(state => state.adminCompanies);
    const dispatch = useDispatch();

    // Eseguo la chiamata iniziale ad admin-companies
    useEffect(() => {
        if (!data) {
            dispatch(getAllCompanies())
        }
    }, [data, dispatch])

    // Imposto il backlink su "/"
    useEffect(() => {
        dispatch(setBacklink("/"))
    }, [dispatch])

    useEffect(() => {
        if (isNeedRefresh) {
            dispatch(getAllCompanies());
            dispatch(setIsNeedCompaniesRefresh(false));
        }
    }, [isNeedRefresh, dispatch])

    return (
                <div className="bg-white p-4 rounded-lg w-full max-w-[1000px] lg:min-w-[1000px]">

                    <div className="w-full flex justify-end mb-8">
                        <GreenButton text="Aggiungi azienda" link="/add-edit-company" isFull />
                    </div>

                    <div className="flex flex-col gap-2 w-full">

                        {/* Cards */}
                        {
                            !isLoading && !error && data && data.length > 0 && data.map((element, index) => {
                                return <AdminCard key={index} elementData={element} type="Company" />
                            })
                        }
                        {isLoading && <Loader isMobileCenter />}
                        {error && <Error message={error.message || 'Errore sconosciuto'} />}

                    </div>
                </div>
    )
}

export default HandleCompanies